(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mara-autumn-hero"] && !Shopify.designMode) return;
  try {
    
  /* Custom elements also reconnect after Shopify theme-editor section reloads. */
  if (!customElements.get('mara-autumn-section')) {
    customElements.define('mara-autumn-section', class extends HTMLElement {
      connectedCallback() {
        if (this._maConnected) return;
        this._maConnected = true;
        this._maButton = this.querySelector('.ma-motion');
        this._maLayer = this.querySelector('.ma-leaves');
        this._maVisible = true;
        this._maPaused = this._maPaused || false;
        this._maMedia = window.matchMedia('(prefers-reduced-motion: reduce)');

        this._maSize = () => {
          const photo = this.querySelector('.ma-photo');
          if (photo) this.style.setProperty('--ma-photo-height', photo.clientHeight + 'px');
          if (this._maLayer) {
            this.style.setProperty('--ma-fall-distance', (this._maLayer.clientHeight + 120) + 'px');
          }
        };
        this._maSync = () => {
          const enabled = !!this._maLayer && !this._maMedia.matches;
          this.toggleAttribute('data-motion-ready', enabled);
          this.toggleAttribute('data-motion-running', enabled && !this._maPaused && this._maVisible && !document.hidden);
          if (this._maButton) {
            this._maButton.hidden = !enabled;
            this._maButton.setAttribute('aria-pressed', String(this._maPaused));
            this._maButton.setAttribute('aria-label', this._maPaused ? 'Starta fallande löv' : 'Pausa fallande löv');
            this._maButton.querySelector('.ma-motion-label').textContent = this._maPaused ? 'Starta löv' : 'Pausa löv';
          }
          this._maSize();
        };
        this._maToggle = () => { this._maPaused = !this._maPaused; this._maSync(); };
        this._maButton?.addEventListener('click', this._maToggle);
        window.addEventListener('resize', this._maSize, { passive: true });
        document.addEventListener('visibilitychange', this._maSync);
        this._maMedia.addEventListener('change', this._maSync);

        if ('IntersectionObserver' in window) {
          this._maIntersection = new IntersectionObserver(entries => {
            this._maVisible = entries[0].isIntersecting;
            this._maSync();
          }, { threshold: 0 });
          this._maIntersection.observe(this);
        }
        if ('ResizeObserver' in window) {
          this._maResize = new ResizeObserver(this._maSize);
          this._maResize.observe(this.querySelector('.ma-scene'));
        }
        this._maSync();
      }
      disconnectedCallback() {
        this._maButton?.removeEventListener('click', this._maToggle);
        window.removeEventListener('resize', this._maSize);
        document.removeEventListener('visibilitychange', this._maSync);
        this._maMedia?.removeEventListener('change', this._maSync);
        this._maIntersection?.disconnect();
        this._maResize?.disconnect();
        this._maConnected = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mara-customer-love"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mara-story-video')) {
  class MaraStoryVideo extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.wantsPlayback = this.dataset.autoplay === 'true' &&
        !this.motion.matches && !this.connection?.saveData;
      this.visible = false;
      this.loaded = !!this.video.getAttribute('src');
      this.playAttempt = 0;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.button.hidden = false;

      this.button.addEventListener('click', () => {
        if (!this.video.paused || this.starting) {
          this.wantsPlayback = false;
          this.pause();
        } else {
          this.wantsPlayback = true;
          this.blocked = false;
          this.failed = false;
          this.querySelector('[data-video-status]').textContent = '';
          this.start();
        }
      }, options);

      this.video.addEventListener('playing', () => {
        if (!this.wantsPlayback || document.hidden || !this.visible) {
          this.pause();
          return;
        }
        this.starting = false;
        this.setAttribute('data-ready', '');
        this.updateButton();
      }, options);
      this.video.addEventListener('pause', () => this.updateButton(), options);
      this.video.addEventListener('error', () => this.fail(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) {
          this.wantsPlayback = false;
          this.pause();
        }
      }, options);
      this.connection?.addEventListener('change', () => {
        if (this.connection.saveData) {
          this.wantsPlayback = false;
          this.pause();
        }
      }, options);

      if ('IntersectionObserver' in window) {
        this.loadObserver = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting) && this.wantsPlayback) {
            this.load();
            this.loadObserver.disconnect();
          }
        }, { rootMargin: '200px 0px' });
        this.loadObserver.observe(this);
        this.playObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
          this.sync();
        }, { threshold: [0, 0.15] });
        this.playObserver.observe(this);
      } else {
        // Older browsers get deliberate click-to-play without background downloads.
        this.visible = true;
        this.wantsPlayback = false;
      }
      this.updateButton();
    }

    load() {
      if (this.loaded) return true;
      const template = this.querySelector('[data-video-sources]');
      const sources = Array.from(template.content.querySelectorAll('source'));
      const mp4s = sources.filter((source) => source.dataset.format === 'mp4')
        .sort((a, b) => Number(a.dataset.width) - Number(b.dataset.width));
      const targetWidth = Math.min(1080, this.clientWidth * Math.min(window.devicePixelRatio || 1, 1.5));
      // Use a suitable Shopify rendition instead of always downloading the largest.
      const chosen = mp4s.find((source) => Number(source.dataset.width) >= targetWidth) ||
        mp4s[mp4s.length - 1] || sources.find((source) => this.video.canPlayType(source.type));
      if (!chosen) {
        this.fail();
        return false;
      }
      this.loaded = true;
      this.video.preload = 'metadata';
      this.video.src = chosen.getAttribute('src');
      this.video.load();
      return true;
    }

    start() {
      if (!this.load() || this.starting || !this.video.paused) return;
      const attempt = ++this.playAttempt;
      this.starting = true;
      this.updateButton();
      const result = this.video.play();
      if (result && typeof result.catch === 'function') {
        result.catch((error) => {
          if (attempt !== this.playAttempt || !this.isConnected) return;
          this.starting = false;
          if (error.name !== 'AbortError') this.blocked = true;
          this.updateButton();
        });
      }
    }

    pause() {
      this.playAttempt++;
      this.starting = false;
      this.video.pause();
      this.updateButton();
    }

    sync() {
      if (this.visible && !document.hidden && this.wantsPlayback && !this.blocked && !this.failed) {
        this.start();
      } else {
        this.pause();
      }
    }

    fail() {
      this.failed = true;
      this.wantsPlayback = false;
      this.loaded = false;
      this.pause();
      this.removeAttribute('data-ready');
      this.querySelector('[data-video-status]').textContent =
        'Videon kunde inte laddas. Tryck på Spela för att försöka igen.';
    }

    updateButton() {
      const playing = !this.video.paused || this.starting;
      this.querySelector('[data-video-icon]').textContent = playing ? 'Ⅱ' : '▶';
      this.querySelector('[data-video-label]').textContent = this.starting ? 'Laddar…' : playing ? 'Pausa' : 'Spela';
      this.button.setAttribute('aria-label', playing ? 'Pausa video' : 'Spela video');
    }

    disconnectedCallback() {
      this.loadObserver?.disconnect();
      this.playObserver?.disconnect();
      this.controller?.abort();
      if (this.video) this.pause();
      this.controller = null;
    }
  }
  customElements.define('mara-story-video', MaraStoryVideo);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mara-jul-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mara-jul-popup')) {
    customElements.define('mara-jul-popup', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.enabled !== 'true') return;
        this.dialog = this.querySelector('dialog');
        this.storageKey = 'mara-jul-signup-dismissed';
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          document.body.style.overflow = this.oldOverflow || '';
          try { localStorage.setItem(this.storageKey, String(Date.now() + Number(this.dataset.days || 7) * 86400000)); } catch {}
        });
        if (window.Shopify?.designMode) return;
        try { if (Date.now() < Number(localStorage.getItem(this.storageKey) || 0)) return; } catch {}
        this.timer = setTimeout(() => {
          if (!this.isConnected || document.querySelector('dialog[open]') || !this.querySelector('.shopify-app-block')) return;
          this.oldOverflow = document.body.style.overflow;
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
        }, Number(this.dataset.delay || 15) * 1000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.oldOverflow || ''; }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
